// Fallback gemini (device lease) fee used only when the live Epoch feed omits geminiFee.
export const DEFAULT_GEMINI_FEE = 10;

export const productMapEpochDTVSatellite = {
  "OF_BASE-CHOICE-ALL-INCLUDED_sales_satellite": "CHOICE™",
  "OF_BASE-ENTERTAINMENT-ALL-INCLUDED_sales_satellite": "ENTERTAINMENT",
  "OF_BASE-ULTIMATE-ALL-INCLUDED_sales_satellite": "ULTIMATE",
  "OF_BASE-PREMIER-ALL-INCLUDED_sales_satellite": "PREMIER",

  "OF_BASE-LO-MAXIMO-ALL-INCLUDED_sales_satellite": "LO MÁXIMO™",
  "OF_BASE-MAS-LATINO-ALL-INCLUDED_sales_satellite": "MÁS LATINO™",
  "OF_BASE-MAS-ULTRA-ALL-INCLUDED_sales_satellite": "MAS ULTRA™",
  "OF_BASE-OPTIMO-MAS-ALL-INCLUDED_sales_satellite": "ÓPTIMO MÁS™",

  "OF_BASE-ENTERTAINMENT-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "ENTERTAINMENT - No Locals",
  "OF_BASE-CHOICE-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "CHOICE™ - No Locals",
  "OF_BASE-ULTIMATE-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "ULTIMATE - No Locals",
  "OF_BASE-PREMIER-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "PREMIER - No Locals",

  "OF_BASE-LO-MAXIMO-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "LO MÁXIMO™ - No Locals",
  "OF_BASE-MAS-LATINO-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "MÁS LATINO™ - No Locals",
  "OF_BASE-MAS-ULTRA-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "MAS ULTRA™ - No Locals",
  "OF_BASE-OPTIMO-MAS-ALL-INCLUDED-NO-LOCALS-LNL_sales_satellite": "ÓPTIMO MÁS™ - No Locals"
}

export const productMapEpochByodGenreMock = {
  "OF_BOLT-MYENTERTAINMENT-202410_GENRE": "ATT_TV_MYENTERTAINMENT",
  "OF_BOLT-MYCINEMA-202410_GENRE": "ATT_TV_MYCINEMA",
  "OF_BOLT-MYKIDS-202410_GENRE": "ATT_TV_MYKIDS",
  "OF_BOLT-MYSPORTS-202410_GENRE": "ATT_TV_MYSPORTS",
  "OF_BOLT-MYSPORTSEXTRA-202410_GENRE": "ATT_TV_MYSPORTS_EXTRA",
  "OF_BOLT-MYHOME-202502_GENRE": "ATT_TV_MYHOMETEAM",
  "OF_BOLT-MYNEWS-202410_GENRE": "ATT_TV_MYNEWS_LOCALS",
  "OF_BOLT-MYESPANOL-202410_GENRE": "ATT_TV_MIESPANOL"
}

export const signatureMap = [
  "ATT_TV_ENTERTAINMENT",
  "ATT_TV_CHOICE",
  "ATT_TV_ULTIMATE",
  "ATT_TV_PREMIER",
  "ATT_TV_OPTIMO_MAS"
];
